import { Injectable } from '@angular/core';
import { ApiCommon } from '@shared/apis/common';
import { Observable } from 'rxjs';
import { ParamsBuilder } from '@shared/models/params-builder';

@Injectable({
  providedIn: 'root'
})
export class PurchasePlaceApi extends ApiCommon {

  getPurchasePlaces(pageEvent, q?: any, query?: any): Observable<any> {
    const builder = new ParamsBuilder();
    builder.pageEvent = pageEvent;
    builder.selectFields = ['company', 'name', 'code', 'displayOrder', 'display'];

    if (q) {
      builder.q = q;
    }

    if (query) {
      builder.query = query;
    }

    if (pageEvent === undefined) {
      builder.sort = 'displayOrder'
    } else if (pageEvent.sort === '') {
      builder.sort = 'displayOrder'
    }

    return this.apiServer.purchasePlace.getPurchasePlaces(builder.build());
  }

  getPurchasePlace(code): Observable<any> {
    return this.apiServer.purchasePlace.getPurchasePlace(code);
  }

  getPurchasePlaceCodes(): Observable<any> {
    return this.apiServer.purchasePlace.getPurchasePlaceCodes();
  }

  savePurchasePlace(purchasePlace): Observable<any> {
    return this.apiServer.purchasePlace.savePurchasePlace(purchasePlace);
  }

  deletePurchasePlace(purchasePlace): Observable<any> {
    return this.apiServer.purchasePlace.deletePurchasePlace(purchasePlace);
  }
}
